import { Link } from "react-router-dom";
//Styles and Icons
import styles from "./Tickets.module.scss";
import Comment_Img1 from "../../../styles/icon/comment_duotone-1.png";
import Comment_Img2 from "../../../styles/icon/comment_duotone.png";
export default function NoTicketToShow() {
  return (
    <div className={styles.noTicket_here_container}>
      <div className={styles.title_tickets_section}>تیکت ها</div>
      <div className={styles.noMessage_section}>
        <div className={styles.noMessage_img}>
          <div className={styles.noMessage_img1}>
            <img src={Comment_Img1} alt="no_message" />
          </div>
          <div className={styles.noMessage_img2}>
            <img src={Comment_Img2} alt="no_message" />
          </div>
        </div>
        <div className={styles.noMessage_title}>شما هیج پیامی ندارید</div>
      </div>
      <div className={styles.place_button}>
        <Link to="/record-ticket">
          <button className={styles.recordTicket_button}>ثبت تیکت</button>
        </Link>
      </div>
    </div>
  );
}
